export default "__VITE_ASSET__DZnMkfN8__"